<template>
  <v-card elevation="3" class="mb-6 rounded-xl">
    <v-card-title class="d-flex align-center mb-2 pb-0 cursor-pointer">
      <!-- @click="mostrarFiltrosGenerales = !mostrarFiltrosGenerales" -->
      <v-icon color="primary" class="mr-3">mdi-filter-variant</v-icon>
      <span class="text-h6 font-weight-bold">Filtros generales</span>
      <v-spacer></v-spacer>
      <v-icon color="primary">
        {{ mostrarFiltrosGenerales ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </v-card-title>

    <v-expand-transition>
      <div v-show="mostrarFiltrosGenerales">
        <v-row class="fill-height" style="min-height: 100%">
          <!-- Columna izquierda -->
          <v-col cols="12" md="6" class="d-flex flex-column">
            <div class="pa-4 pt-0">
              <v-row dense>
                <!-- Filtros -->
                <v-col cols="12">
                  <v-select
                    v-model="filtroFideicomiso"
                    :items="fideicomisos"
                    item-text="nombre"
                    item-value="nombre"
                    label="Fideicomiso"
                    outlined
                    dense
                    clearable
                    :multiple="!requiereFideicomisoUnico"
                    :chips="!requiereFideicomisoUnico"
                    :deletable-chips="!requiereFideicomisoUnico"
                    :hint="
                      requiereFideicomisoUnico
                        ? 'Este reporte requiere seleccionar un único fideicomiso'
                        : ''
                    "
                    persistent-hint
                    append-icon="mdi-chevron-down"
                    :small-chips="!requiereFideicomisoUnico"
                    :disabled="filtersDisabled.fideicomiso"
                    @change="onFideicomisoChange"
                    @input="onFideicomisoInput"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="filtroTipoServicio"
                    :items="tiposServiciosFiltrados"
                    item-text="nombre"
                    item-value="id"
                    label="Tipo de Operatoria"
                    outlined
                    dense
                    clearable
                    append-icon="mdi-chevron-down"
                    :disabled="filtersDisabled.tipoServicio"
                    @change="onTipoServicioChange"
                  />
                </v-col>

                <v-col cols="12">
                  <v-select
                    v-model="filtroOperatoria"
                    :items="operatoriasDisponibles"
                    item-text="nombre"
                    item-value="nombre"
                    label="Operatoria"
                    outlined
                    dense
                    clearable
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    append-icon="mdi-chevron-down"
                    :disabled="filtersDisabled.operatoria || operatoriasDisponibles.length === 0 || loading"
                    :loading="loading"
                    :hint="getOperatoriaHint()"
                    persistent-hint
                    @change="onOperatoriaChange"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="estadoSeleccionado"
                    :items="solicitudEstados"
                    item-text="nombre"
                    item-value="id"
                    label="Estado de la solicitud"
                    outlined
                    dense
                    clearable
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    append-icon="mdi-chevron-down"
                    :disabled="filtersDisabled.estadoSolicitud"
                    @change="onEstadoChange"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    v-model="filtroTipoPersona"
                    :items="tiposPersona"
                    label="Tipo de Persona"
                    outlined
                    dense
                    clearable
                    append-icon="mdi-chevron-down"
                    :disabled="filtersDisabled.tipoPersona"
                  />
                </v-col>
              </v-row>

              <!-- Filtro de Departamentos -->
              <v-row v-if="!ocultarDepartamentos" dense>
                <v-col cols="12">
                  <v-select
                    v-model="filtroDepartamento"
                    :items="departamentos"
                    item-text="nombre"
                    item-value="id"
                    label="Departamentos"
                    outlined
                    dense
                    clearable
                    multiple
                    chips
                    deletable-chips
                    small-chips
                    append-icon="mdi-chevron-down"
                    :disabled="filtersDisabled.departamento"
                    @change="onDepartamentoChange"
                  />
                </v-col>
              </v-row>

              <!-- Rango de fechas -->
              <div v-if="!ocultarRangoFechas" class="text-subtitle-1 font-weight-medium mt-6 mb-2">
                <v-icon class="mr-2" color="primary">mdi-calendar-range</v-icon>
                Rango de fechas
              </div>

              <v-row v-if="!ocultarRangoFechas" dense>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    :disabled="filtersDisabled.fechaDesde"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaInicioFormateada"
                        label="Desde fecha"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :disabled="filtersDisabled.fechaDesde"
                        :error="esInfoCobranzas && !esFechaDesdeValida"
                        :error-messages="
                          esInfoCobranzas && !esFechaDesdeValida
                            ? 'La fecha desde debe ser menor al día de hoy'
                            : ''
                        "
                      />
                    </template>
                    <v-date-picker
                      v-model="fechaInicio"
                      :max="esInfoCobranzas ? fechaActual : null"
                      @input="menu1 = false"
                    />
                  </v-menu>
                </v-col>

                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    :disabled="filtersDisabled.fechaHasta"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechaFinalFormateada"
                        label="Hasta fecha"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :disabled="filtersDisabled.fechaHasta"
                        :error="
                          (esInfoCobranzasProyectadas && !esFechaHastaValida) ||
                          (esInfoCobranzas && !esFechaHastaValidaInfoCobranzas)
                        "
                        :error-messages="getErrorMessageFechaHasta()"
                      />
                    </template>
                    <v-date-picker
                      v-model="fechaFinal"
                      :min="esInfoCobranzasProyectadas ? fechaActual : null"
                      :max="esInfoCobranzas ? fechaActual : null"
                      @input="menu2 = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>

            

              <v-row v-if="muestraOpcionSubtotales" dense>
                <v-col cols="12">
                  <v-switch
                    v-model="mostrarSubtotales"
                    label="Mostrar subtotales por operatoria"
                    color="primary"
                    hide-details
                    :disabled="
                      isInfoMoraActive ||
                      esInfoCobranzasProyectadas ||
                      esInfoCobranzas
                    "
                    @change="onSubtotalesChange"
                  />
                  <div
                    v-if="
                      mostrarSubtotales &&
                      !isInfoMoraActive &&
                      !esInfoCobranzasProyectadas &&
                      !esInfoCobranzas
                    "
                    class="caption text--secondary mt-1"
                  >
                    Los subtotales agrupan los registros por operatoria
                    mostrando totales parciales
                  </div>
                  <div
                    v-if="
                      isInfoMoraActive ||
                      esInfoCobranzasProyectadas ||
                      esInfoCobranzas
                    "
                    class="caption text--secondary mt-1"
                  >
                    <template v-if="isInfoMoraActive">
                      Los subtotales no están disponibles para el reporte Info
                      Mora
                    </template>
                    <template v-else-if="esInfoCobranzasProyectadas">
                      Los subtotales no están disponibles para Info Cobranzas
                      Proyectadas
                    </template>
                    <template v-else-if="esInfoCobranzas">
                      Los subtotales no están disponibles para Info Cobranzas
                    </template>
                  </div>
                </v-col>
              </v-row>
              

              <!-- Empujar contenido para igualar altura -->
              <div class="flex-grow-1"></div>
            </div>
          </v-col>

          <!-- Columna derecha -->
          <v-col
            cols="12"
            md="6"
            class="d-flex flex-column"
            style="min-height: auto"
          >
            <div>
              <v-card class="pa-4 elevation-1 d-flex flex-column resumen-card">
                <div
                  class="text-subtitle-1 font-weight-medium mb-4 d-flex align-center"
                >
                  <v-icon class="mr-2" color="primary"
                    >mdi-information-outline</v-icon
                  >
                  Resumen de filtros:
                </div>

                <v-simple-table dense class="resumen-filtros">
                  <template v-slot:default>
                    <tbody>
                      <tr
                        v-for="filtro in filtrosActivos"
                        :key="filtro.id"
                        class="fila-resumen"
                      >
                        <td class="campo-label font-weight-bold">
                          {{ filtro.etiqueta }}
                        </td>
                        <td class="valor-cell">
                          <!-- Si es fideicomiso con múltiples selecciones -->
                          <div
                            v-if="
                              filtro.id === 'fideicomiso' &&
                              filtro.fideicomisoNombres &&
                              filtro.fideicomisoNombres.length > 0
                            "
                            class="chips-container"
                          >
                            <v-chip
                              v-for="fideicomisoNombre in filtro.fideicomisoNombres"
                              :key="fideicomisoNombre"
                              small
                              class="mr-1 mb-1 filtro-chip"
                              :title="fideicomisoNombre"
                            >
                              {{ truncarTexto(fideicomisoNombre, 30) }}
                            </v-chip>
                          </div>
                          <!-- Si es operatoria con múltiples selecciones -->
                          <div
                            v-else-if="
                              filtro.id === 'operatoria' &&
                              filtro.operatoriaNombres &&
                              filtro.operatoriaNombres.length > 0
                            "
                            class="chips-container"
                          >
                            <v-chip
                              v-for="operatoriaNombre in filtro.operatoriaNombres"
                              :key="operatoriaNombre"
                              small
                              class="mr-1 mb-1 filtro-chip"
                              :title="operatoriaNombre"
                            >
                              {{ truncarTexto(operatoriaNombre, 35) }}
                            </v-chip>
                          </div>
                          <!-- Si es estado con múltiples selecciones -->
                          <div
                            v-else-if="
                              filtro.id === 'estadoSolicitud' &&
                              filtro.estadosNombres &&
                              filtro.estadosNombres.length > 0
                            "
                            class="chips-container"
                          >
                            <v-chip
                              v-for="estadoNombre in filtro.estadosNombres"
                              :key="estadoNombre"
                              small
                              class="mr-1 mb-1 filtro-chip"
                              :title="estadoNombre"
                            >
                              {{ truncarTexto(estadoNombre, 30) }}
                            </v-chip>
                          </div>
                          <!-- Si es departamento con múltiples selecciones -->
                          <div
                            v-else-if="
                              filtro.id === 'departamentos' &&
                              filtro.departamentosNombres &&
                              filtro.departamentosNombres.length > 0
                            "
                            class="chips-container"
                          >
                            <v-chip
                              v-for="deptoNombre in filtro.departamentosNombres"
                              :key="deptoNombre"
                              small
                              class="mr-1 mb-1 filtro-chip"
                              :title="deptoNombre"
                            >
                              {{ truncarTexto(deptoNombre, 30) }}
                            </v-chip>
                          </div>
                          <!-- Para otros filtros -->
                          <div v-else class="valor-simple">
                            <div
                              class="valor-text elipsis-text"
                              :class="{
                                'texto-por-defecto': filtro.esPorDefecto,
                              }"
                            >
                              {{ filtro.nombre }}
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card>
            </div>

            <!-- Espaciador flexible -->
            <div class="flex-grow-1" style="min-height: 20px"></div>

            <!-- Botones al fondo -->
            <div class="mt-6 mb-7">
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-btn
                    block
                    color="error"
                    class="elevation-2 transition-button"
                    @click="onLimpiarFiltros"
                  >
                    <v-icon left>mdi-broom</v-icon>
                    Limpiar Filtros
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                    block
                    color="success"
                    class="elevation-2 transition-button"
                    :disabled="!puedeGenerarReporte || loading"
                    :loading="loading"
                    @click="onGenerarReporte"
                  >
                    <v-icon left>mdi-file-document-outline</v-icon>
                    Generar Reporte
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
export default {
  name: 'ReportFiltersSection',
  props: {
    fideicomisos: {
      type: Array,
      default: () => [],
    },
    tiposServiciosFiltrados: {
      type: Array,
      default: () => [],
    },
    operatoriasDisponibles: {
      type: Array,
      default: () => [],
    },
    solicitudEstados: {
      type: Array,
      default: () => [],
    },
    tiposPersona: {
      type: Array,
      default: () => ['Física', 'Jurídica', 'Ambas'],
    },
    departamentos: {
      type: Array,
      default: () => [],
    },
    filtrosActivos: {
      type: Array,
      default: () => [],
    },
    puedeGenerarReporte: {
      type: Boolean,
      default: false,
    },
    filtersDisabled: {
      type: Object,
      default: () => ({
        tipoServicio: false,
        estadoSolicitud: false,
        fideicomiso: false,
        operatoria: false,
        tipoPersona: false,
        fechas: false,
      }),
    },
    esOperacion: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    reporteEspecialActivo: {
      type: String,
      default: null,
    },
    // Nuevas props para sincronización con el padre
    filtroFideicomisoParent: {
      type: [Array, String],
      default: () => [],
    },
    filtroTipoServicioParent: {
      type: [String, Number],
      default: null,
    },
    filtroOperatoriaParent: {
      type: Array,
      default: () => [],
    },
    estadoSeleccionadoParent: {
      type: Array,
      default: () => [],
    },
    filtroTipoPersonaParent: {
      type: String,
      default: 'Ambas',
    },
    filtroDepartamentoParent: {
      type: Array,
      default: () => [],
    },
    fechaInicioParent: {
      type: String,
      default: '2020-01-01',
    },
    fechaFinalParent: {
      type: String,
      default: () => new Date().toISOString().substr(0, 10),
    },
  },
  emits: [
    'fideicomiso-change',
    'tipo-servicio-change',
    'operatoria-change',
    'estado-change',
    'departamento-change',
    'remove-fideicomiso',
    'remove-operatoria',
    'remove-estado',
    'remove-filter',
    'limpiar-filtros',
    'generar-reporte',
    'update:filtro-fideicomiso',
    'update:filtro-tipo-servicio',
    'update:filtro-operatoria',
    'update:estado-seleccionado',
    'update:filtro-tipo-persona',
    'update:filtro-departamento',
    'update:fecha-inicio',
    'update:fecha-final',
    'subtotales-change',
  ],
  data() {
    return {
      mostrarFiltrosGenerales: true,
      mostrarSubtotales: false,
      menu1: false,
      menu2: false,
      filtroFideicomiso: [],
      filtroTipoServicio: null,
      filtroOperatoria: [],
      estadoSeleccionado: [],
      filtroTipoPersona: 'Ambas',
      filtroDepartamento: [],
      fechaInicio: '2020-01-01',
      fechaFinal: new Date().toISOString().substr(0, 10),
    };
  },
  computed: {
    esFinanciamiento() {
      // Buscar si el tipo de servicio seleccionado es "Financiamiento"
      const tipoSeleccionado = this.tiposServiciosFiltrados.find(
        (ts) => ts.id === this.filtroTipoServicio
      );
      return tipoSeleccionado && tipoSeleccionado.nombre === 'Financiamiento';
    },
    muestraOpcionSubtotales() {
    

      // No mostrar subtotales para Info Cte y No Cte ni para Reporte de Saldos - HTC
      if (this.reporteEspecialActivo === 'Info Cte y No Cte' ||
          this.reporteEspecialActivo === 'Reporte de Saldos - HTC') {
        console.log('✅ Ocultando subtotales para:', this.reporteEspecialActivo);
        return false;
      }
    
      return this.esFinanciamiento;
    },
    isInfoMoraActive() {
      return this.reporteEspecialActivo === 'Info Mora (Financiamiento)';
    },
    requiereFideicomisoUnico() {
      return (
        this.reporteEspecialActivo === 'Info Mora (Financiamiento)' ||
        this.reporteEspecialActivo === 'Info Cobranzas Proyectadas' ||
        this.reporteEspecialActivo === 'Info Cobranzas' ||
        this.reporteEspecialActivo === 'Info Cte y No Cte' ||
        this.reporteEspecialActivo === 'Reporte de Saldos - HTC'
      );
    },
    ocultarRangoFechas() {
      return this.reporteEspecialActivo === 'Info Cte y No Cte' ||
             this.reporteEspecialActivo === 'Reporte de Saldos - HTC';
    },
    ocultarDepartamentos() {
      return this.reporteEspecialActivo === 'Info Cte y No Cte' ||
             this.reporteEspecialActivo === 'Reporte de Saldos - HTC';
    },
    fechaInicioFormateada() {
      if (!this.fechaInicio) return '';
      const [year, month, day] = this.fechaInicio.split('-');
      return `${day}/${month}/${year}`;
    },
    fechaFinalFormateada() {
      if (!this.fechaFinal) return '';
      const [year, month, day] = this.fechaFinal.split('-');
      return `${day}/${month}/${year}`;
    },
    fechaActual() {
      return new Date().toISOString().substr(0, 10);
    },
    esFechaHastaValida() {
      // Solo validar para Info Cobranzas Proyectadas
      if (this.reporteEspecialActivo !== 'Info Cobranzas Proyectadas')
        return true;
      if (!this.fechaFinal) return true;
      return this.fechaFinal > this.fechaActual;
    },
    esFechaDesdeValida() {
      // Solo validar para Info Cobranzas
      if (this.reporteEspecialActivo !== 'Info Cobranzas') return true;
      if (!this.fechaInicio) return true;
      return this.fechaInicio < this.fechaActual;
    },
    esFechaHastaValidaInfoCobranzas() {
      // Solo validar para Info Cobranzas
      if (this.reporteEspecialActivo !== 'Info Cobranzas') return true;
      if (!this.fechaFinal) return true;
      return this.fechaFinal <= this.fechaActual;
    },
    esInfoCobranzasProyectadas() {
      return this.reporteEspecialActivo === 'Info Cobranzas Proyectadas';
    },
    esInfoCobranzas() {
      return this.reporteEspecialActivo === 'Info Cobranzas';
    },
  },
  methods: {
    isEmptyReactiveObject(obj) {
      // Función auxiliar para detectar objetos reactivos vacíos de Vue
      return (
        obj &&
        typeof obj === 'object' &&
        obj.constructor === Object &&
        Object.keys(obj).length === 1 &&
        obj.hasOwnProperty('__ob__')
      );
    },
    onFideicomisoChange() {
      console.log(
        '🔄 ReportFiltersSection.onFideicomisoChange - valor:',
        this.filtroFideicomiso
      );
      console.log('🔧 Tipo:', typeof this.filtroFideicomiso);
      console.log(
        '🔧 Es reactive object?:',
        this.isEmptyReactiveObject(this.filtroFideicomiso)
      );

      this.$emit('fideicomiso-change', this.filtroFideicomiso);
      this.$emit('update:filtro-fideicomiso', this.filtroFideicomiso);
    },
    onFideicomisoInput(value) {
      console.log(
        '📝 ReportFiltersSection.onFideicomisoInput - valor recibido:',
        value
      );
      console.log('📝 Tipo de value:', typeof value);
      console.log('📝 isInfoMoraActive:', this.isInfoMoraActive);
      console.log('📝 requiereFideicomisoUnico:', this.requiereFideicomisoUnico);
      console.log('📝 filtroFideicomiso actual:', this.filtroFideicomiso);

      // Actualizar el valor local y emitir eventos
      this.filtroFideicomiso = value;

      this.$emit('fideicomiso-change', this.filtroFideicomiso);
      this.$emit('update:filtro-fideicomiso', this.filtroFideicomiso);
    },
    onTipoServicioChange() {
      this.$emit('tipo-servicio-change', this.filtroTipoServicio);
      this.$emit('update:filtro-tipo-servicio', this.filtroTipoServicio);
    },
    onOperatoriaChange() {
      this.$emit('operatoria-change', this.filtroOperatoria);
      this.$emit('update:filtro-operatoria', this.filtroOperatoria);
    },
    onEstadoChange() {
      this.$emit('estado-change', this.estadoSeleccionado);
      this.$emit('update:estado-seleccionado', this.estadoSeleccionado);
    },
    onDepartamentoChange() {
      this.$emit('departamento-change', this.filtroDepartamento);
      this.$emit('update:filtro-departamento', this.filtroDepartamento);
    },
    onRemoveFideicomiso(fideicomisoNombre) {
      this.$emit('remove-fideicomiso', fideicomisoNombre);
    },
    onRemoveOperatoria(operatoriaNombre) {
      this.$emit('remove-operatoria', operatoriaNombre);
    },
    onRemoveEstado(estadoNombre) {
      this.$emit('remove-estado', estadoNombre);
    },
    onRemoveFilter(filtroId) {
      this.$emit('remove-filter', filtroId);
    },
    onLimpiarFiltros() {
      this.filtroFideicomiso = [];
      this.filtroTipoServicio = null;
      this.filtroOperatoria = [];
      this.estadoSeleccionado = [];
      this.filtroTipoPersona = 'Ambas';
      this.filtroDepartamento = [];
      this.reiniciarFechas();
      this.mostrarSubtotales = false;
      this.$emit('limpiar-filtros');
    },
    getErrorMessageFechaHasta() {
      if (this.esInfoCobranzasProyectadas && !this.esFechaHastaValida) {
        return 'La fecha hasta debe ser mayor a la fecha actual';
      }
      if (this.esInfoCobranzas && !this.esFechaHastaValidaInfoCobranzas) {
        return 'La fecha hasta debe ser menor o igual al día de hoy';
      }
      return '';
    },
    onGenerarReporte() {
      // Validar que se haya seleccionado un fideicomiso para reportes que lo requieren
      if (this.requiereFideicomisoUnico) {
        if (!this.filtroFideicomiso || this.filtroFideicomiso === null) {
          this.$swal({
            icon: 'error',
            title: 'Fideicomiso Requerido',
            text: 'Debe seleccionar un fideicomiso específico para generar este reporte.',
            confirmButtonText: 'Entendido',
          });
          return;
        }
        if (this.filtroFideicomiso === 'Todas') {
          this.$swal({
            icon: 'error',
            title: 'Selección Específica Requerida',
            text: 'Para este reporte debe seleccionar un fideicomiso específico, no "Todas".',
            confirmButtonText: 'Entendido',
          });
          return;
        }
      }

      // Validar fechas para Info Cobranzas Proyectadas
      if (this.esInfoCobranzasProyectadas && !this.esFechaHastaValida) {
        this.$swal({
          icon: 'error',
          title: 'Error en fecha',
          text: 'La fecha hasta debe ser mayor a la fecha actual',
          confirmButtonText: 'Entendido',
        });
        return;
      }

      // Validar fechas para Info Cobranzas
      if (this.esInfoCobranzas) {
        if (!this.esFechaDesdeValida) {
          this.$swal({
            icon: 'error',
            title: 'Error en fecha desde',
            text: 'La fecha desde debe ser menor al día de hoy',
            confirmButtonText: 'Entendido',
          });
          return;
        }
        if (!this.esFechaHastaValidaInfoCobranzas) {
          this.$swal({
            icon: 'error',
            title: 'Error en fecha hasta',
            text: 'La fecha hasta debe ser menor o igual al día de hoy',
            confirmButtonText: 'Entendido',
          });
          return;
        }
      }

      this.$emit('generar-reporte');
    },
    truncarTexto(texto, maxLength) {
      if (texto.length <= maxLength) return texto;
      return texto.substr(0, maxLength) + '...';
    },
    onSubtotalesChange() {
      this.$emit('subtotales-change', this.mostrarSubtotales);
    },
    getOperatoriaHint() {
      if (this.loading) {
        return this.reporteEspecialActivo === 'Info Mora (Financiamiento)'
          ? 'Cargando operatorias para el fideicomiso seleccionado...'
          : 'Cargando operatorias...';
      }
      if (this.operatoriasDisponibles.length === 0) {
        return this.reporteEspecialActivo === 'Info Mora (Financiamiento)'
          ? 'Seleccione primero un fideicomiso específico'
          : 'Seleccione primero un tipo de operatoria';
      }
      return '';
    },
    reiniciarFechas() {
      this.fechaInicio = '2020-01-01';
      this.fechaFinal = new Date().toISOString().substr(0, 10);
    },
  },
  watch: {
    filtroTipoPersona() {
      this.$emit('update:filtro-tipo-persona', this.filtroTipoPersona);
    },
    filtroDepartamento() {
      this.$emit('update:filtro-departamento', this.filtroDepartamento);
    },
    fechaInicio() {
      this.$emit('update:fecha-inicio', this.fechaInicio);
    },
    fechaFinal() {
      this.$emit('update:fecha-final', this.fechaFinal);
    },
    // Watchers para sincronizar valores del padre con el estado local
    filtroFideicomisoParent: {
      handler(newVal) {
        console.log('👁️ Watcher filtroFideicomisoParent - newVal:', newVal);
        console.log('👁️ Tipo:', typeof newVal);
        console.log('👁️ isInfoMoraActive:', this.isInfoMoraActive);

        // Si es un objeto reactivo vacío, tratarlo como valor vacío
        if (this.isEmptyReactiveObject(newVal)) {
          console.log('⚠️ Detectado objeto reactivo vacío, limpiando valor');
          if (this.requiereFideicomisoUnico) {
            this.filtroFideicomiso = null;
          } else {
            this.filtroFideicomiso = [];
          }
          return;
        }

        // Para reportes que requieren fideicomiso único, puede ser string (selección única) o array (selección múltiple)
        if (this.requiereFideicomisoUnico) {
          // Si viene un array, tomar el primer elemento, sino usar el valor directamente
          if (Array.isArray(newVal) && newVal.length > 0) {
            console.log(
              '🔄 Convirtiendo array a string para reporte único:',
              newVal[0]
            );
            this.filtroFideicomiso = newVal[0];
          } else if (typeof newVal === 'string') {
            console.log('✅ Manteniendo string para reporte único:', newVal);
            this.filtroFideicomiso = newVal;
          } else {
            console.log('🧹 Limpiando filtroFideicomiso para reporte único');
            this.filtroFideicomiso = null;
          }
        } else {
          // Para reportes normales, mantener como array
          this.filtroFideicomiso = Array.isArray(newVal)
            ? newVal
            : newVal
            ? [newVal]
            : [];
          console.log(
            '📝 Establecido como array para reporte normal:',
            this.filtroFideicomiso
          );
        }
      },
      immediate: true,
    },
    filtroTipoServicioParent: {
      handler(newVal) {
        this.filtroTipoServicio = newVal;
      },
      immediate: true,
    },
    filtroOperatoriaParent: {
      handler(newVal) {
        this.filtroOperatoria = newVal || [];
      },
      immediate: true,
    },
    estadoSeleccionadoParent: {
      handler(newVal) {
        this.estadoSeleccionado = newVal || [];
      },
      immediate: true,
    },
    filtroTipoPersonaParent: {
      handler(newVal) {
        if (newVal) this.filtroTipoPersona = newVal;
      },
      immediate: true,
    },
    filtroDepartamentoParent: {
      handler(newVal) {
        this.filtroDepartamento = newVal || [];
      },
      immediate: true,
    },
    fechaInicioParent: {
      handler(newVal) {
        if (newVal) this.fechaInicio = newVal;
      },
      immediate: true,
    },
    fechaFinalParent: {
      handler(newVal) {
        if (newVal) this.fechaFinal = newVal;
      },
      immediate: true,
    },
    reporteEspecialActivo: {
      handler(newVal, oldVal) {
        // Reiniciar fechas cuando se cambie a Info Mora
        if (
          newVal === 'Info Mora (Financiamiento)' &&
          oldVal !== 'Info Mora (Financiamiento)'
        ) {
          console.log('🔄 Cambiando a Info Mora - reiniciando fechas');
          this.reiniciarFechas();
        }
        // Desactivar subtotales para Info Cobranzas Proyectadas
        if (
          newVal === 'Info Cobranzas Proyectadas' &&
          oldVal !== 'Info Cobranzas Proyectadas'
        ) {
          console.log(
            '🔄 Cambiando a Info Cobranzas Proyectadas - desactivando subtotales'
          );
          this.mostrarSubtotales = false;
          this.$emit('subtotales-change', this.mostrarSubtotales);
        }
        // Desactivar subtotales para Info Cobranzas
        if (newVal === 'Info Cobranzas' && oldVal !== 'Info Cobranzas') {
         
          this.mostrarSubtotales = false;
          this.$emit('subtotales-change', this.mostrarSubtotales);
        }
        // Desactivar subtotales para Info Cte y No Cte
        if (newVal === 'Info Cte y No Cte' && oldVal !== 'Info Cte y No Cte') {
         
          this.mostrarSubtotales = false;
          this.$emit('subtotales-change', this.mostrarSubtotales);
        }
        // Desactivar subtotales para Reporte de Saldos - HTC
        if (newVal === 'Reporte de Saldos - HTC' && oldVal !== 'Reporte de Saldos - HTC') {
         
          this.mostrarSubtotales = false;
          this.$emit('subtotales-change', this.mostrarSubtotales);
        }
      },
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.resumen-card {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
}

.resumen-filtros {
  background-color: transparent;
  box-shadow: none !important;
}

.resumen-filtros table {
  box-shadow: none !important;
}

.resumen-filtros .v-data-table {
  box-shadow: none !important;
}

.resumen-filtros tr {
  border-bottom: none !important;
}

.resumen-filtros tbody tr:not(:last-child) td {
  border-bottom: 1px solid #e0e0e0 !important;
}

.resumen-filtros tbody tr:last-child td {
  border-bottom: none !important;
}

.fila-resumen {
  vertical-align: top;
}

.fila-resumen td {
  padding: 8px 4px !important;
  vertical-align: middle !important;
}

.fila-resumen .campo-label {
  white-space: nowrap !important;
  word-break: keep-all !important;
  min-width: 180px !important;
  max-width: none !important;
}

.fila-resumen:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.campo-label {
  width: 40%;
  min-width: 180px;
  color: #666;
  font-size: 0.875rem;
  font-family: inherit;
  white-space: nowrap !important;
  overflow: visible !important;
  text-overflow: initial !important;
}

.valor-text {
  flex: 1;
  color: #333;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: inherit;
}

.elipsis-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  min-width: 120px;
}

.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  min-height: 32px;
  align-items: flex-start;
  align-content: flex-start;
}

/* Unificar tipografía en chips */
.chips-container .v-chip {
  font-size: 0.875rem !important;
  font-family: inherit !important;
  font-weight: 500 !important;
  height: 24px !important;
  margin: 2px 0 !important;
  color: #333 !important;
}

/* Estilo específico para chips de filtros */
.filtro-chip {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}

/* Color del icono de cerrar en chips */
.filtro-chip .v-icon {
  color: #757575 !important;
}

.filtro-chip:hover .v-icon {
  color: #424242 !important;
}

/* Unificar tipografía en el título del resumen */
.resumen-card .text-subtitle-1 {
  font-size: 0.875rem !important;
  font-family: inherit !important;
}

.transition-button {
  transition: all 0.3s ease;
}

.transition-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.texto-por-defecto {
  color: #9e9e9e !important;
  font-style: italic;
}

/* Evitar solapamiento en v-select con chips */
::v-deep .v-select.v-text-field--outlined .v-select__selection--comma {
  margin-top: 6px !important;
}

::v-deep
  .v-select.v-text-field--outlined.v-text-field--dense
  .v-select__selections {
  min-height: 40px !important;
}

::v-deep
  .v-select.v-text-field--outlined.v-text-field--dense
  .v-select__selection {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}

::v-deep .v-input--dense .v-chip--small {
  height: 20px !important;
  font-size: 12px !important;
}

::v-deep .v-select.v-text-field--outlined .v-input__slot {
  min-height: 40px !important;
}

::v-deep .v-text-field--outlined.v-text-field--dense .v-label {
  top: 6px !important;
}

::v-deep .v-text-field--outlined.v-text-field--dense .v-label--active {
  transform: translateY(-18px) scale(0.75) !important;
}

/* Evitar fondo azul en los chips de los v-select */
::v-deep .v-select .v-chip {
  background-color: #e0e0e0 !important;
  color: #000000de !important;
}

::v-deep .v-select .v-chip--active {
  background-color: #1976d2 !important;
  color: white !important;
}

/* Resetear estilos de chips que puedan venir del Dashboard */
::v-deep .v-select .theme--light.v-chip:not(.v-chip--active) {
  background-color: #e0e0e0 !important;
}
</style>
